import { API_URL } from '../../../app-config/constants';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/email-verifications`;

type IsVerified = {
    address: string;
    verified: boolean;
};

isVerified.operation = 'READ';
isVerified.idFrom = 'ARGS';
export function isVerified(email: string, company?: string) {
    return get<IsVerified>(`${BASE_URL}/${email}/verified`, company ? { getData: { company } } : undefined);
}

export function resend(email: string) {
    return post<void>(`${BASE_URL}/${email}/resend`);
}

verify.invalidates = ['isVerified'];
export function verify(postData: { address: string; token: string }) {
    return post<void>(BASE_URL, { postData });
}
